// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__14Y5W","colMin":"styles_colMin__o7qmu","colCheckbox":"styles_colCheckbox__1k1Tv"};